import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m12 18.28-.62-.5C11.16 17.6 6 13.42 6 8c0-3.31 2.69-6 6-6s6 2.69 6 6c0 5.42-5.16 9.61-5.38 9.78zM12 4C9.79 4 8 5.79 8 8c0 3.44 2.74 6.45 4 7.66 1.26-1.21 4-4.22 4-7.66 0-2.21-1.79-4-4-4m5.01 11.99-1.53 1.53c.99.34 1.52.77 1.52.98 0 .39-1.72 1.5-5 1.5s-5-1.11-5-1.5c0-.21.53-.63 1.52-.98l-1.53-1.53C5.79 16.58 5 17.41 5 18.5c0 2.3 3.52 3.5 7 3.5s7-1.2 7-3.5c0-1.09-.79-1.92-1.99-2.51M12 11c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3m0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }